export default {
  QueryParams: {
    Category: 'catdir',
    Area: 'area',
    Scope: 'scope',
    Experience: 'experience',
    Cv: 'cv',
    FreeSearch: 'searchterm',
    Geolexid: 'geolexid',
    Range: 'range',
    Ssaen: 'ssaen'
  },

  UrlPart: {
    Category: 'cat',
    SubCategory: 'subcat',
    Area: 'area',
    What: 'search',
    Cv: 'cv',
  },

  STS: {
    DisplayString: 'displayString',
    SearchType: 'type',
    SearchTypeIdentifier: 'typeRelativeId',
    SearchByCategory: 'drushim_category_id',
    SearchBySubCategory: 'drushim_sub_category_id',
    SearchByCompanyName: 'company_name',
    RegionIds: 'drushim_region_ids',
    RegionSeparator: ';',
    Jd: 'jd'
  },

  Types: {
    Object: 'object',
    String: 'String'
  },

  Constants: {
    MultipleSeparator: '-',
    ClearFilterButtonText: 'נקה בחירה',
    SaveFilterButtonText: 'שמירה',
    MultipleChoiceButtonText: 'בחירה מרובה',
    MinDisplayWidth: 768,
    CookieName: 'search',
    DefaultBaseUrl: '/jobs/',
    DefaultBaseUrlNoCv: '/משרות-ללא-קורות-חיים/',
    WhatPlaceHolder: 'חפש/י את העבודה הבאה שלך',
    WherePlaceHolder: 'איפה העבודה הבאה שלך?',
    SearchTitle: 'זה מה שחיפשת:',
    SearchTitleNoCv: 'זה מה שחיפשת במשרות ללא קו"ח:',
    FilteringOptions: 'אפשרויות סינון:',
    FilteringOptionsNoCv: 'אפשרויות סינון של משרות ללא קו"ח:',
    CvFilterTitle: 'קורות חיים:',
    ResetFilters: 'התחל חיפוש חדש',
    LoadMoreButtonText: 'הצג לי משרות נוספות'
  },

  ssaen: {
    RegularSearch: 1,
    FilterSearch: 3
  },

  FilterTitle: {
    Category: 'קטגוריה',
    SubCategory: 'תחום',
    Area: 'איזור',
    Experience: 'שנות נסיון',
    Scope: 'היקף משרה'
  }
}
